//  process.env.NODE_ENV //环境变量 需要改   'development'|'production'

export const $NODE_ENV = 'production'
const $file_path = ''
export const BASE = {
	$file_path,
	$NODE_ENV,
	// 自定义主题颜色  css配置在:uni.scss
	$ossurl: 'https://download.khyyyzd.com' + $file_path,
	$main_color: '#446CF1',
	$bg_color: '#446CF1',
	$f6: '#666',
	$f9: '#999',
	$f97: '#979997',
}

export const development = {
	$DOMAIN: 'http://120.46.211.32:9525/api',
	...BASE
}
export const production = {
	$DOMAIN: 'https://dashapi.khyyyzd.com/api',
	...BASE
}
//app只能使用http|https請求
// #ifdef H5
// development.$DOMAIN = '/dev_api'
// #endif

export default {
	development,
	production
} [$NODE_ENV]